<script lang="ts">
    import { DatePicker, H3, Label } from "attractions";
    import { onMount } from "svelte";
    import { PICKED_DATE_RANGE_FOR_REPORT, PICKED_EMPLOYEE_TO_REPORT } from "../../../Stores/Report";
    import Currency from "../../../Utils/Currency";
    import Chart from "../../Chart/Chart.svelte";

    let chartContainer: HTMLDivElement;
    let pickedEmployeeToReport;
    let productsChartLabels: string[] = [];
    let productsChartValues: any[] = [];

    const defaultDateRange = {
        start: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        end: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
    }

    function handleChangeDateRange(e) {
        const pickedDateRange = e.detail.value;
        PICKED_DATE_RANGE_FOR_REPORT.set(pickedDateRange);
    }

    PICKED_EMPLOYEE_TO_REPORT.subscribe(data => {
        pickedEmployeeToReport = data;
        productsChartLabels = [];
        productsChartValues = [];
        if (pickedEmployeeToReport) {
            for (const [label, value] of Object.entries(pickedEmployeeToReport.purchasesSummary.purchasesCount.byProduct)) {
                productsChartLabels.push(label);
                productsChartValues.push(value);
            }
            if (chartContainer) {
                chartContainer.innerHTML = null;
                new Chart({
                    target: chartContainer,
                    props: {
                        label: "Ilość",
                        labels: productsChartLabels,
                        data: productsChartValues
                    }
                })
            }
        }
    });

    onMount(() => PICKED_DATE_RANGE_FOR_REPORT.set(defaultDateRange));
</script>

{#if pickedEmployeeToReport}
    <section class="shortSummary">
        <div class="employeeName">
            <Label small style="margin-bottom: .25rem">Generujesz raport dla pracownika</Label>
            <H3>{pickedEmployeeToReport.firstname} {pickedEmployeeToReport.lastname}</H3>
        </div>
        <div class="dateRange">
            <Label style="margin: .5rem 0">Zakres dat</Label>
            <DatePicker on:change={handleChangeDateRange} range value={defaultDateRange}>
                <span slot="between-inputs">-</span>
            </DatePicker>
            <!-- <H3 style="margin: 0">do {new Date().toLocaleDateString()}</H3>
            <small>Możliwość zmiany zakresu dat jest przewidziana do wdrożenia w przyszłych wersjach aplikacji.</small> -->
        </div>
        <div class="employeePurchasesCounter">
            <div class="card">
                <Label small style="margin-bottom: .25rem">Zakupów łącznie</Label>
                <H3>{pickedEmployeeToReport.purchasesSummary.purchasesCount.sumaric}</H3>
            </div>
            <div class="card">
                <Label small style="margin-bottom: .25rem">Zakupów łącznie</Label>
                <H3>{Currency.format(pickedEmployeeToReport.purchasesSummary.purchasesAmount.sumaric)}</H3>
            </div>
        </div>
        <section class="employeePurchasesByProductChart">
            <Label small style="margin-bottom: .25rem">Zakupy według produktów</Label>
            <div bind:this={chartContainer}></div>
        </section>
        <section class="employeeGetDetailsReport">
            <a class="button" href="/#/getSummaryReport/{pickedEmployeeToReport._id}" target="_blank">Wygeneruj raport szczegółowy</a>
        </section>
    </section>
{/if}

<style lang="scss">
    .shortSummary {
        .employee {
            &Name {
                margin-top: .5rem;
            }

            &PurchasesCounter {
                display: flex;
                margin-top: .5rem;

                .card {
                    margin-right: 1rem;
                }
            }

            &PurchasesByProductChart {
                margin-top: .5rem;
            }

            &GetDetailsReport {
                a.button {
                    background: white;
                    border: 1px solid gray;
                    border-radius: 5px;
                    display: flex;
                    margin-top: .75rem;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    text-decoration: none;
                    padding: 6.4px;
                    color: #333;
                }
            }
        }

        .dateRange {
            small {
                color: gray;
                max-width: 330px;
                font-size: .5rem;
            }
        }
    }
</style>
